ready().then(function () {

    const addOverlayOnBookItem = () => {
        $(document).on("click", ".card-book", function (e) {
            e.preventDefault();

            removeAllOverlays();

            const url = $(this).find('.anchor-full-overlay').attr("href");
            const img = $(this).find(".img-container img").attr("src");

            $(this).append("<div class='overlay-book-b2b'><p>Je vindt alle informatie over dit boek op onze website kinderboeken.nl.</p></div>");

            $(this).find('.overlay-book-b2b').append("<img class='overlay-book-img' src='" + img + "'/>");
            $(this).find('.overlay-book-b2b').append("<a class='btn btn-secondary has-icon icon-external-link-square'><span class='btn-text'>Bekijk boek</span></a>");
            $(this).find('.overlay-book-b2b').wrap("<a target='_blank' class='overlay-book-link' href='" + url + "'></a>");

            $(this).closest('.ui-grid-item').toggleClass('has-active-overlay');
            $(this).closest('.swiper-slide').toggleClass('has-active-overlay');
        }).on('click', 'a.overlay-book-link', function (e) {
            window.open($(this).attr("href"));
        });
    }

    const addOverlayOnAuthorItem = () => {
        $(document).on("click", ".card-author", function (e) {
            e.preventDefault();

            removeAllOverlays();

            const url = $(this).find('.anchor-full-overlay').attr("href");

            $(this).append("<div class='overlay-author-b2b'><p>Je vindt alle informatie over deze auteur op onze website kinderboeken.nl.</p></div>");

            $(this).find('.overlay-author-b2b').append("<a class='btn btn-secondary has-icon icon-external-link-square'><span class='btn-text'>Bekijk auteur</span></a>");
            $(this).find('.overlay-author-b2b').wrap("<a target='_blank' class='overlay-author-link' href='" + url + "'></a>");
        }).on('click', 'a.overlay-author-link', function (e) {
            window.open($(this).attr("href"));
        });
    }

    const removeAllOverlays = () => {
        $('.ui-grid-item').removeClass('has-active-overlay');
        $('.swiper-slide').removeClass('has-active-overlay');
        $('.overlay-book-link').remove();
        $('.overlay-author-link').remove();
    }

    addOverlayOnBookItem();
    addOverlayOnAuthorItem();

});
